/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

export const mapNeighborhoods = (hoods: any, neighborhoodIds: any) => {
  const hoodNames = []
  for (let i = 0; i < neighborhoodIds.length; i++) {
    const hood = hoods.find((hood: any) => hood.neighborhoodId === neighborhoodIds[i])
    if (hood) {
      hoodNames.push(hood.name)
    }
  }
  return hoodNames
}
